import type { SerializedDockview } from "dockview";

import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ApplicationEnum } from "~/@types/enums";

export const DOCK_LAYOUT_SCHEMA_VERSION = 1;

export interface DockLayoutState {
	dockLayoutSchemaVersion?: number;
	layouts: Partial<Record<ApplicationEnum, SerializedDockview>>;
	tenantId?: string;
	userEmail?: string;
}

const initialState: DockLayoutState = {
	layouts: {}
};

export interface SetDockLayoutPayload {
	module: ApplicationEnum;
	layout: SerializedDockview;
}

export interface ClearDockLayoutPayload {
	module: ApplicationEnum;
}

export const dockLayoutSlice = createSlice({
	initialState,
	name: "dockLayout",
	reducers: {
		clearDockLayout: (state, action: PayloadAction<ClearDockLayoutPayload>) => {
			delete state.layouts[action.payload.module];
		},
		setDockLayout: (state, action: PayloadAction<SetDockLayoutPayload>) => {
			state.layouts[action.payload.module] = action.payload.layout;
		}
	}
});

export const { clearDockLayout, setDockLayout } = dockLayoutSlice.actions;

export default dockLayoutSlice.reducer;
